import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { CitationType } from '../citations';

export interface WebsitePreviewModalData {
  fileName?: string;
  fileUrl: string;
  liveUrl?: string;
  citationType: CitationType;
}

@Component({
  selector: 'inbox-website-preview-modal',
  templateUrl: './website-preview-modal.component.html',
  styleUrls: ['./website-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogContent,
    MatDialogClose,
    MatDialogTitle,
    MatIconButton,
    TranslateModule,
    MatIconModule,
    GalaxyAlertModule
],
})
export class WebsitePreviewModalComponent {
  private readonly data = inject(MAT_DIALOG_DATA);
  dialogData: WebsitePreviewModalData = this.data;

  // Only show preview for supported citation types
  isSupported = computed(() => {
    const type = this.dialogData.citationType;
    return type === CitationType.TYPE_WEBSITE || type === CitationType.TYPE_WEBSITE_V2;
  });

  safeFileUrl = computed<SafeResourceUrl | null>(() => {
    const url = this.dialogData.fileUrl;
    return url && this.isSupported() ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  });

  liveUrlForAction = computed<string | undefined>(() => {
    return this.dialogData.liveUrl ?? undefined;
  });

  constructor(
    public dialogRef: MatDialogRef<WebsitePreviewModalComponent>,
    private sanitizer: DomSanitizer,
  ) {}
}
